import { Box, Loader, Text, Avatar, Section } from '@acast/decibel';
import styled from 'styled-components';
import { resolve } from 'acast-www-utils';
import { Episode, Show } from 'client/resources';
import React from 'react';
import { DEFAULT_COVER_IMAGE } from 'resources/show/schema';
import RichTextEditor from 'shared/components/rich-text-editor';
import resourceProp from 'shared/helpers/resource-prop';
import { typography } from '@acast/decibel/dist/cjs/styles';

const EditorContainer = styled.div`
  & .rich-text-editor .quill {
    & .ql-container {
      border: none;
      ${typography.body2}
    }

    & .ql-editor {
      min-height: 40px;
      padding: 0;
    }
  }
`;

const EpisodeDetails = (props, context) => {
  const { episode } = context;
  const { show } = props;

  return (
    <Section>
      <Box gap={6}>
        <Avatar
          size="xxlarge"
          src={episode.data.image || DEFAULT_COVER_IMAGE}
          type="square"
          title={episode.data.name || ''}
        />
        <Box flexDirection="column" flexGrow={1} overflow="hidden">
          <Text variant="h4" mb={1}>
            {episode.data.name}
          </Text>
          <Text variant="subtitle2" mb={2}>
            <Box>By {resolve(show, 'data.name', <Loader width={8} />)}</Box>
          </Text>
          <EditorContainer>
            <RichTextEditor value={episode.data.description} readOnly toolbar={null} />
          </EditorContainer>
        </Box>
      </Box>
    </Section>
  );
};

EpisodeDetails.contextTypes = {
  episode: resourceProp(Episode),
};

EpisodeDetails.propTypes = {
  show: resourceProp(Show),
};

export default Show.connect('show', 'showId')(EpisodeDetails);
